import styles from './Avatar.module.css'

interface Props {
  nome: string
  cognome?: string
  taglia?: 'sm' | 'md' | 'lg'
}

export function Avatar({ nome, cognome, taglia = 'md' }: Props) {
  const iniziali = (nome.charAt(0) + (cognome?.charAt(0) ?? '')).toUpperCase()
  return <div className={`${styles.avatar} ${styles[taglia]}`}>{iniziali || '?'}</div>
}
